import md5 from 'js-md5';
import commonJs from '../public/common'
import axios from 'axios'
import router from "../router/index";
import {Notify} from 'vant';

// import qs from 'qs'
// import {handleError} from '../public/error-info'

//console.log(axios.options)

axios.defaults.withCredentials = false

// 创建axios实例 超时时间
const axiosInstance = axios.create({
  // withCredentials：表示跨域请求时是否需要使用凭证
  withCredentials: false
});

axiosInstance.defaults.withCredentials = false

// const baseApi = process.env.MCR_API;    //api网关（小马哥）

let uploadFileApi = process.env.UPLOAD_FILE_API;    //api网关   上传图片

// 公共路径
let baseApi
// 上传
let uploadApi
let  saleWorkerApi = process.env.SALE_API;    // 个性化页面-代理营销员工接口
let locationHost = window.location.host
if (locationHost.includes('localhost') || locationHost.includes('80')) {
  uploadApi = process.env.BASE_API;


 baseApi = process.env.BASE_API + '/api';    //api网关（测试）

 //  baseApi = process.env.MCR_API + '/api';    //api网关（小马哥)

  // baseApi = process.env.XZL_API + '/api';    //api网关（许张隆）

  // baseApi = process.env.WPG_API + '/api';    //api网关（鹏刚）

  // baseApi = process.env.HKZ_API + '/api';    //api网关（黄克知）

  // baseApi = process.env.WYL_API + '/api';    //api网关（王一龙）

  // baseApi = process.env.ZTT_API + '/api';    //api网关（赵婷婷）

  // baseApi = process.env.LZL_API + '/api';    //api网关（李祖林）
  saleWorkerApi = process.env.SALE_API;    // 个性化页面-代理营销员工接口


} else {
  if (window.location.href.includes('https')) {
    baseApi = "https://" + locationHost + '/api'
    uploadApi = "https://" + locationHost
  } else {
    baseApi = "http://" + locationHost + '/api'
    uploadApi = "http://" + locationHost
  }
}

// axios 发生错误的请求（401、403、500）
let ajaxErrorBool = true;

// 白名单（不加loading效果）
let whiteList1 = [
  '/queryPriceResult',//轮循询价
  '/queryUnderWriteResult',//轮循核保
  '/queryUploadImageResult',//轮循影像件
]

//白名单（不加 authorization  eg：登录注册等）
let whiteList2 = [
  "/login/mobileLogin",
  "/login/pcLogin",
  "/login/userLogin",
  "/login/sendActivateCode",
  "/login/checkPcLoginCode",
  "/login/sendLoginCode",
  "/login/smsLogin",
  "/vehicle/uploadFile",
  "/searchBranchAgentExtra",
  '/shareQuoteInfo',
  '/sendBizLoginCode',
  '/smsBizLogin',
  'loadChannelConfigWater',
]

// http request 拦截器
axiosInstance.interceptors.request.use(
  config => {   // 在请求发出之前进行一些操作
    let blackBool = true;   // 默认使用loading
    let whiteList2Bool = true;   // 默认加token
    // loading 关闭
    commonJs.finishLoading();

    // 白名单不加loading效果
    for (var i = 0; i < whiteList1.length; i++) {
      if (config.url.toLocaleLowerCase().indexOf(whiteList1[i].toLocaleLowerCase()) != -1) {
        blackBool = false;
        break
      }
    }
    if (blackBool) {
      // loading 开始
      commonJs.beginLoading()
    }
    // 白名单不加token
    for (var i = 0; i < whiteList2.length; i++) {
      if (config.url.toLocaleLowerCase().indexOf(whiteList2[i].toLocaleLowerCase()) != -1) {
        whiteList2Bool = false;
        break
      }
    }
    if (whiteList2Bool) {
      // 没有用户标识  即需要用户去登陆
      if (!localStorage['token']) {
        commonJs.getToken()
      } else {
        config.headers['token'] = localStorage['token'] || commonJs.getQueryString('token');      //有用户标识 则将用户标识符设置为请求头
      }
    }
   // return Promise.resolve(config)
    // config.startTime = +new Date
    return config
  },
  error => {
    // MessageBox.alert(error, '接口请求错误', {
    //   confirmButtonText: '确定',
    // });
    if (!!error) {
      return Promise.reject(error);
    }
  }
)

/**
 * http response 拦截器
 * resp.data.code:
 *    403: 无权限
 *    401：登录无效
 *    200：成功，正常
 */
axiosInstance.interceptors.response.use(
  resp => {     //在这里对返回的数据进行处理
    // loading 关闭
    commonJs.finishLoading();
    if (resp.status == 200) {
      if(resp.config.url.includes('vehicle/loadChannelConfig') && resp.data.errorCode == 903){
        sessionStorage['channelErrorMessage'] = resp.data.errorMessage || ""
        router.push({path: '/errorTips',})
        return  false
      }
      if (typeof (resp.data.success) == 'undefined') {
        return Promise.resolve(resp);
      } else {
        if (resp.config.url.indexOf('/login/checkPcLoginCode') != -1) {
          return Promise.resolve(resp);
        } else {
          if (resp.data.success) {
            return Promise.resolve(resp);
          } else {
            if (resp.data.errorCode == 12) {
              localStorage.clear()
              sessionStorage.clear()
              commonJs.getToken()
            } else {
              if (resp.data.errorCode != 13) {
                Notify(resp.data.errorMessage);
              }
            }
            return false
          }
        }

      }
    } else {
      Notify(resp.statusText);
      return false
    }
  },
  error => {

    // error.config.duration = +new Date - error.config.startTime
    console.log(error)
    // loading 关闭
    commonJs.finishLoading();
    return Promise.reject(error);
  }
);
export default {
  UploadFiles(url, data) {     //post请求
    data.append("output", 'json2');
    data.append("scene", 'pc-dff');
    if (url.indexOf('http') == -1) {
      url = uploadApi + url;
    }
    var obj = {
      method: 'post',
      url,
      data,
      // timeout: 60000,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data'
      }
    }, params = {};
    params = obj;
    return axiosInstance(params);
  },
  uploadFile(url, formData, gateway) {
    if (url.indexOf('http') == -1) {
      url = eval(gateway) + url;
    }
    // var requestPath=process.env.VUE_APP_SERVER_BASE_PATH+api.uploadFile;
    return axios.post(url, formData, {
      withCredentials: true,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  downFile(method, url, data) {     //post请求
    if (url.indexOf('http') == -1) {
      url = baseApi + url;
    }
    // TODO md5加密 只能加密字符串
    let timestamp = Number(new Date()).toString()
    let md5Str = data ? JSON.stringify(data) + timestamp : timestamp
    var obj = {
        method: method,
        url,
        data,
        // timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/json; charset=UTF-8',
          'timestamp': timestamp,
          'sign': md5(md5Str)
        }
      },
      params = Object.assign(obj, {responseType: 'blob'});//请求文件流
    return axiosInstance(params);
  },
  post(url, data, responseType,type) {     //post请求
    if (url.indexOf('http') == -1 && type) {
      console.log(saleWorkerApi)
      url = saleWorkerApi + url;
    }else {
      url = baseApi + url;
    }
    // TODO md5加密 只能加密字符串
    let timestamp = Number(new Date()).toString()
    let md5Str = data ? JSON.stringify(data) + timestamp : timestamp
    var obj = {
      method: 'post',
      url,
      data,
      // timeout: 60000,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        'timestamp': timestamp,
        'sign': md5(md5Str)
      }
    }, params = {};
    if (responseType)
      params = Object.assign(obj, {responseType: 'blob'});//请求文件流
    else
      params = obj;
    return axiosInstance(params);
  },
  postForm(url, data) {     //post请求form表单提交
    if (url.indexOf('http') == -1) {
      url = baseApi + url;
    }
    var obj = {
        method: 'post',
        url,
        transformRequest: [function (data) {//在请求之前对data传参进行格式转换
          let ret = ''
          for (let item in data) {
            ret += encodeURIComponent(item) + '=' + encodeURIComponent(data[item]) + '&'
          }
          ret = ret.slice(0, ret.length - 1)
          return ret
        }],
        // transformRequest: [function(data) {//在请求之前对data传参进行格式转换
        //   data = Qs.stringify(data)
        //   return data
        // }],
        data: data,
        // timeout: 60000,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        }
      },
      params = obj;
    return axiosInstance(params);
  },

  get(url, params) {        //get请求
    if (url.indexOf('http') == -1) {
      url = baseApi + url;
    }
    // TODO md5加密 只能加密字符串
    let timestamp = Number(new Date()).toString()
    let md5Str = data ? JSON.stringify(data) + timestamp : timestamp
    var obj = {
      method: 'get',
      url,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'timestamp': timestamp,
        'sign': md5(md5Str)
      }
    };
    if (params) obj.params = params;
    return axiosInstance(obj);
  },

  delete(url, data) {        //delete请求
    if (url.indexOf('http') == -1) {
      url = baseApi + url;
    }
    var obj = {
      method: 'delete',
      url,
      data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8'
      }
    };
    // if (params) obj.params = params;
    return axiosInstance(obj);
  },

  put(url, data) {        //put请求
    if (url.indexOf('http') == -1) {
      url = baseApi + url;
    }
    return axiosInstance({
      method: 'put',
      url,
      data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': 'application/json; charset=UTF-8',
        // 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/public/ajax.js